import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@/App';
import '@/index.css';

// Hide initial loading screen once React mounts
const hideLoadingScreen = () => {
  const loading = document.getElementById('initial-loading');
  if (loading) {
    loading.classList.add('hidden');
  }
};

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Hide loading screen after React mounts
setTimeout(hideLoadingScreen, 100);
window.addEventListener('load', hideLoadingScreen);
